import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { ShopProvider } from "./context/ShopContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <CartProvider>   {/* ✅ Wrap here */}
      <WishlistProvider>
        <ShopProvider>
         <App />
        </ShopProvider>
      </WishlistProvider>
    </CartProvider>
  </BrowserRouter>
);

reportWebVitals();
